import { render, staticRenderFns } from "./EmailCustomerModal.vue?vue&type=template&id=3270390e"
import script from "./EmailCustomerModal.vue?vue&type=script&lang=js"
export * from "./EmailCustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports